import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { FloatingLabelInput as Input, SelectableBlock } from '../../../Elements';
import Option from './Option';

const Fees = ({ contractVariables, textFieldChange, yesNoChange }) => (
  <div>
    <h3>What is your overtime fee per half hour?</h3>
    <Input
      name='overtimeRate'
      type='currency'
      placeholder='$100.00'
      value={contractVariables.overtimeRate}
      onChange={textFieldChange}
      required
      validationError='Required'
      inline
    >
      <NumberFormat
        thousandSeparator
        prefix={'$'}
        decimalScale={2}
        fixedDecimalScale
      />
    </Input>
    <h3>Do you charge an additional fee for outdoor events?</h3>
    <Option>
      <SelectableBlock
        name='outdoorSurcharge'
        content='Yes'
        value='yes'
        radio
        checked={contractVariables.outdoorSurcharge}
        onChange={yesNoChange}
      />
    </Option>
    <Option>
      <SelectableBlock
        name='outdoorSurcharge'
        content='No'
        value='no'
        radio
        checked={!contractVariables.outdoorSurcharge}
        onChange={yesNoChange}
      />
    </Option>
  </div>
);

Fees.propTypes = {
  yesNoChange: PropTypes.func.isRequired,
  contractVariables: PropTypes.object.isRequired,
  textFieldChange: PropTypes.func.isRequired
};

export default Fees;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/TermsBuilder/Fees.js